// src/config/financialFlows.js
// Valid From→To account-type combinations, per MD_CONFIG flow matrix.
// Keys are lowercase to match real accounts.type values in your DB.
// true = permitted, false/absent = blocked.

// v0.33 build 54 (R6): extended for the legitimate flows the original matrix rejected —
// Opening equity/loan→inventory, Capital cash/bank→immobilisation, Inventory
// Reconciliation expense→inventory, and the credit expense supplier→expense. The server
// mirrors this matrix (server.js FLOW_MATRIX) and enforces it on every posting path.
// 948 (N1) — THE LOCAL COPY IS GONE; this reads the server's matrix, which is the enforcer.
// It used to be a hand-maintained table whose own header claimed "the server mirrors this matrix". The
// reverse was true and it had drifted NINE cells behind: measured live 2026-08-19, it blocked 6 flows the
// server permits across 221 POSTED legs (supplier->git 94 · git->inventory 88 · cash->git 26 · bank->git 9
// · git->expense 3 · client->expense 1), and it had no `git` FROM-row at all — it could not express two of
// those even in principle. The client->expense cell is the absorb-deduct the server REQUIRES for A9-green.
//
// 🔴 SAFE TO ADOPT WHOLESALE, verified before the switch rather than assumed: the server matrix admits
// EVERY live posted flow (27 distinct cells / 1,556 legs, zero blocked-but-live), and there is NO cell
// where the web was right and the server wrong — which is the case that would have made this a
// server-tightening decision for the owner instead of a web sync. The 3 cells the server permits with no
// live legs yet are deliberate: expense->client (755 R-8, owner-ruled) and expense->cash|bank (875).
//
// DRIFT PREVENTION: there is no table here to fall behind. Adding a cell server-side changes what the web
// permits with no web edit.
let _matrix = null;
export function loadFlowMatrix(fetchJson) {
  return Promise.resolve(fetchJson('/flow-matrix')).then(m => { if (m && typeof m === 'object') _matrix = m; return _matrix; });
}
export const financialFlows = new Proxy({}, { get: (_t, k) => (_matrix || {})[k] });


export function isFlowValid(fromType, toType) {
  if (!fromType || !toType) return true;
  // 948 — NOT-YET-LOADED PERMITS, deliberately. Both consumers are ADVISORY (they warn before a save the
  // server independently enforces), so an unloaded matrix must fail toward "let the server answer", never
  // toward blocking a legitimate entry on missing config. Same posture 829 chose for the account picker:
  // fail toward a LOUD server refusal, never toward a silent local block.
  if (!_matrix) return true;
  return Boolean(_matrix[fromType.toLowerCase()]?.[toType.toLowerCase()]);
}

// Per-subtype account-flow direction for the finance-door loan legs — the single source
// of truth so every finance form (DataEntryPage FinanceForm + Forms/LinkedTransactionFields)
// books the same direction, not a per-form hardcode. Values are the valid account TYPES on
// each side (from = source, to = destination); both sides are cash/bank/loan only — NO partner
// accounts, since loans are not partner-attributed the way payables/receivables are.
//
// Ledger ruling LOAN-LEG-DIRECTION-BORROW-IS-LOAN-TO-CASH-REPAY-IS-CASH-TO-LOAN (owner, 2026-07-28),
// mirroring the locked flow matrix above (loan→cash/bank AND cash/bank→loan are both permitted):
//   Loan Borrowing (funds come IN):  Loan (source)      → Cash/Bank (destination)
//   Loan Repayment (funds go OUT):   Cash/Bank (source) → Loan (destination)
export const FINANCE_SUBTYPE_FLOW = {
  'Loan Borrowing': { from: ['loan'], to: ['cash', 'bank'] },
  'Loan Repayment': { from: ['cash', 'bank'], to: ['loan'] },
};

export const isLoanSubtype = (subtype) =>
  subtype === 'Loan Borrowing' || subtype === 'Loan Repayment';
